import React from 'react';
import PropTypes from 'prop-types';
import fetch from 'isomorphic-fetch';
import CategoryCard from './CategoryCard';
import CategoryToolTile from './CategoryToolTile';

const RecommendRow = props => {
  const { content = {}, fptiClick, fptiImpression, toolTileProps } = props;

  const {
    flatPSData: { categories = {} }
  } = toolTileProps;

  let { featured = [] } = props;

  const handleClickCategory = fptiLink => {
    // fpti link is either the category/section OR 'viewall'
    // if 'viewall': pass 'viewall to handleClickCategory'
    fptiClick({
      fptiLink:
        (typeof fptiLink === 'string' && fptiLink) || content.categoryFPTI,
      category: 'parent',
      pageLink: content.categoryFPTI
    });
    fetch(content.PSClickUrl);
  };

  const handleClickTool = ({
    fptiLink,
    prod,
    PSUrl,
    categoryRank,
    appKey,
    rank,
    priorityScore
  }) => {
    return () => {
      fptiClick({
        fptiLink,
        prod,
        pageLink: content.categoryFPTI,
        categoryRank,
        appKey,
        rank,
        priorityScore
      });
      fetch(PSUrl);
    };
  };

  featured = featured.map(tool => {
    const { categoryKey = '' } = tool;
    const loc = categories[categoryKey] ? categories[categoryKey].location : '';
    return {
      ...tool,
      categoryLocation: loc
    };
  });

  return (
    <div className="appcenter-category">
      <div className="category-header">
        <h3>{content.categoryTitle}</h3>
      </div>
      <div className="category-row">
        {featured.map((tool, index) => (
          <CategoryToolTile
            key={`category-row-tool-${index}`}
            handleClickTool={handleClickTool}
            tool={tool}
            path={`/appcenter/${tool.categoryLocation}`}
            fptiImpression={fptiImpression}
            toolTileProps={toolTileProps}
            pageLink={content.categoryFPTI}
          />
        ))}
        <CategoryCard
          content={content}
          handleClick={handleClickCategory}
          fptiImpression={fptiImpression}
          isRecommendCategory={true}
        />
      </div>
    </div>
  );
};

RecommendRow.propTypes = {
  featured: PropTypes.array,
  content: PropTypes.object,
  fptiClick: PropTypes.func,
  viewAllText: PropTypes.string,
  fptiImpression: PropTypes.func,
  toolTileProps: PropTypes.object
};

export default RecommendRow;
